import { DialogDOMUtils } from './dom_utils'

// Centralizes event binding/unbinding for dialog-related events
export class DialogEventHandler {
  constructor(rootElement) {
    this.root = rootElement
    this.localCleanups = []
  }

  registerGlobal({ onEscape, onWindowDismiss, onGlobalSubmitEnd } = {}) {
    this.boundHandleKeydown = (e) => {
      if (e.key === 'Escape') onEscape && onEscape(e)
    }
    document.addEventListener('keydown', this.boundHandleKeydown)

    this.boundWindowDismiss = () => onWindowDismiss && onWindowDismiss()
    window.addEventListener('dialog:dismiss', this.boundWindowDismiss)

    this.boundGlobalSubmitEnd = (e) => onGlobalSubmitEnd && onGlobalSubmitEnd(e)
    document.addEventListener('turbo:submit-end', this.boundGlobalSubmitEnd)
  }

  unregisterGlobal() {
    if (this.boundHandleKeydown) document.removeEventListener('keydown', this.boundHandleKeydown)
    if (this.boundWindowDismiss) window.removeEventListener('dialog:dismiss', this.boundWindowDismiss)
    if (this.boundGlobalSubmitEnd) document.removeEventListener('turbo:submit-end', this.boundGlobalSubmitEnd)
  }

  registerLocalFor(dialogEl, { onBackdropClick, onCloseButtonClick, onSubmitEnd } = {}) {
    if (!dialogEl) return

    const backdrop = DialogDOMUtils.getBackdrop(dialogEl)
    if (backdrop) {
      const handler = (e) => { if (e.target === backdrop) onBackdropClick && onBackdropClick(e) }
      backdrop.addEventListener('click', handler)
      this.localCleanups.push(() => { try { backdrop.removeEventListener('click', handler) } catch (_) {} })
    }

    const closeButtons = DialogDOMUtils.getCloseButtons(dialogEl)
    closeButtons.forEach(button => {
      const handler = (e) => { e.preventDefault(); onCloseButtonClick && onCloseButtonClick(e) }
      button.addEventListener('click', handler)
      this.localCleanups.push(() => { try { button.removeEventListener('click', handler) } catch (_) {} })
    })

    const submitEndHandler = (e) => onSubmitEnd && onSubmitEnd(e)
    dialogEl.addEventListener('turbo:submit-end', submitEndHandler)
    this.localCleanups.push(() => { try { dialogEl.removeEventListener('turbo:submit-end', submitEndHandler) } catch (_) {} })
  }

  unregisterLocal() {
    this.localCleanups.forEach(fn => { try { fn() } catch (_) {} })
    this.localCleanups = []
  }
}

